export default __webpack_public_path__ + "assets/images/0975f3228dda3341569d029c2f7b08a3.mp3";